import { request, getBaseUrl, sessionFetch } from './http';
import { cachedRead } from './readCache';

export async function getSites(options = {}) {
  const includeInactive = options?.includeInactive === true;
  const q = includeInactive ? '?includeInactive=1' : '';
  const key = includeInactive ? 'sites:all' : 'sites:active';
  return cachedRead(key, () => request(`/facilities/${q}`));
}

export async function getFacilities(options = {}) {
    return getSites(options);
  }

export async function getPwsReportSection(section, params = {}) {
    const q = new URLSearchParams({ section: String(section) });
    Object.entries(params).forEach(([key, value]) => {
      if (value != null && value !== '') q.set(key, String(value));
    });
    return request(`/pws/report/preview?${q}`);
  }

export async function exportPwsReportPptx(payload) {
    const response = await sessionFetch(`${getBaseUrl()}/api/pws/report/export-pptx`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      let message = 'Failed to export PowerPoint';
      try {
        const err = await response.json();
        message = err.message || message;
      } catch {
        // ignore
      }
      throw new Error(message);
    }

    return response.blob();
  }

export async function downloadPwsReportTemplate() {
    const response = await sessionFetch(`${getBaseUrl()}/api/pws/report/template`);
    if (!response.ok) {
      throw new Error('Failed to download PWS report template');
    }
    return response.blob();
  }

export async function uploadPwsReportTemplate(file) {
    const formData = new FormData();
    formData.append('template', file);
    const response = await sessionFetch(`${getBaseUrl()}/api/pws/report/template`, {
      method: 'POST',
      body: formData
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.message || 'Failed to upload template');
    }
    return data;
  }

export async function getPWSFacilities() {
  return cachedRead('sites:pws', async () => {
    const paths = ['/facilities/pws', '/pws/sites'];
    for (const path of paths) {
      try {
        const res = await request(path);
        if (res?.success && Array.isArray(res.data) && res.data.length > 0) {
          return res;
        }
      } catch (err) {
        console.warn(`[getPWSFacilities] ${path} failed:`, err?.message || err);
      }
    }
    console.warn('[getPWSFacilities] falling back to /facilities/');
    return getSites();
  });
}

export async function getSitesByCompany(customerId) {
    return request('/facilities/by-customer', {
      method: 'POST',
      body: JSON.stringify({ customerId })
    });
  }

export async function getFacilitiesByCompany(customerId) {
    return getSitesByCompany(customerId);
  }

export async function getFacilityContainerInfo(facilityId) {
    return request(`/facilities/${facilityId}/container-info`);
  }

export const facilitiesSitesApi = {
  getSites,
  getFacilities,
  getPwsReportSection,
  exportPwsReportPptx,
  downloadPwsReportTemplate,
  uploadPwsReportTemplate,
  getPWSFacilities,
  getSitesByCompany,
  getFacilitiesByCompany,
  getFacilityContainerInfo,
};

